var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _g, _g2, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _g3, _path218, _path219, _path220, _path221, _path222, _path223;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 527,
    height: 394,
    viewBox: "0 0 527 394",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M527 345.916H0V346.18H527V345.916Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.094 353.094H110.185V353.357H145.094V353.094Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.332 362.749H180.381V363.012H223.332V362.749Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.131 359.45H55.2929V359.713H109.131V359.45Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M474.195 354.865H376.025V355.128H474.195V354.865Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M366.644 354.865H359.972V355.128H366.644V354.865Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M336.69 359.313H292.179V359.576H336.69V359.313Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M249.798 298.908H46.2811C44.6868 298.905 43.1587 298.27 42.0323 297.141C40.9059 296.013 40.2733 294.484 40.2733 292.89V6.80231C40.2872 5.21712 40.9259 3.70142 42.0508 2.58443C43.1757 1.46744 44.6959 0.839385 46.2811 0.83667H249.798C251.394 0.83667 252.925 1.47074 254.054 2.5994C255.182 3.72806 255.816 5.25885 255.816 6.85501V6.85501V292.89C255.816 294.486 255.182 296.017 254.054 297.145C252.925 298.274 251.394 298.908 249.798 298.908V298.908ZM46.2811 1.04747C44.7567 1.05026 43.2956 1.6578 42.2186 2.73674C41.1417 3.81568 40.5368 5.27786 40.5368 6.80231V292.89C40.5368 294.414 41.1417 295.876 42.2186 296.955C43.2956 298.034 44.7567 298.642 46.2811 298.644H249.798C251.323 298.639 252.783 298.031 253.861 296.953C254.939 295.875 255.547 294.414 255.553 292.89V6.80231C255.547 5.27774 254.939 3.8172 253.861 2.73916C252.783 1.66112 251.323 1.05302 249.798 1.04747H46.2811Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M477.789 298.908H274.261C272.667 298.902 271.139 298.266 270.012 297.139C268.884 296.012 268.249 294.484 268.243 292.89V6.80231C268.26 5.21616 268.901 3.70047 270.027 2.58377C271.154 1.46708 272.675 0.839356 274.261 0.83667H477.789C479.372 0.842155 480.89 1.47144 482.012 2.58813C483.135 3.70482 483.772 5.21894 483.786 6.80231V292.89C483.787 293.678 483.633 294.46 483.333 295.189C483.032 295.919 482.591 296.582 482.034 297.141C481.477 297.7 480.815 298.143 480.087 298.447C479.359 298.75 478.578 298.906 477.789 298.908V298.908ZM274.261 1.04747C272.737 1.05302 271.276 1.66112 270.198 2.73916C269.12 3.8172 268.512 5.27774 268.507 6.80231V292.89C268.512 294.414 269.12 295.875 270.198 296.953C271.276 298.031 272.737 298.639 274.261 298.644H477.789C479.313 298.639 480.774 298.031 481.852 296.953C482.93 295.875 483.538 294.414 483.544 292.89V6.80231C483.538 5.27774 482.93 3.8172 481.852 2.73916C480.774 1.66112 479.313 1.05302 477.789 1.04747H274.261Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4863 123.206H165.931C165.931 123.206 161.009 111.76 144.567 115.322C144.567 115.322 141.11 102.305 128.567 104.108C128.567 104.108 118.185 92.8509 103.039 97.2145C87.8932 101.578 89.2001 115.322 89.2001 115.322C89.2001 115.322 77.9961 112.392 74.4863 123.206Z",
    fill: "#FAFAFA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M319.246 53.4735H227.811C227.811 53.4735 232.723 42.0165 249.165 45.579C249.165 45.579 252.623 32.5621 265.176 34.3645C265.176 34.3645 275.558 23.1183 290.693 27.4818C305.829 31.8454 304.543 45.579 304.543 45.579C304.543 45.579 315.789 42.6594 319.246 53.4735Z",
    fill: "#FAFAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M386.681 50.4906H456.635C456.635 50.4906 453.958 40.8887 443.839 44.0507C443.839 44.0507 445.947 31.1286 438.485 29.6319C431.023 28.1353 428.651 37.9691 428.651 37.9691C426.944 36.0338 424.729 34.6137 422.258 33.8689C419.787 33.124 417.157 33.0839 414.665 33.7531C412.213 34.3913 409.98 35.6788 408.199 37.48C406.418 39.2811 405.156 41.5292 404.546 43.9874C404.546 43.9874 392.088 36.8518 386.681 50.4906Z",
    fill: "#FAFAFA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.542 177.034H48.4418V345.642H133.542V177.034Z",
    fill: "#E6E6E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.069 177.034H48.4418V345.642H118.069V177.034Z",
    fill: "#F0F0F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.543 177.034H46.608V179.785H134.543V177.034Z",
    fill: "#E0E0E0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M134.543 171.532H46.608V174.283H134.543V171.532Z",
    fill: "#E0E0E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.699 174.283H48.4418V177.034H132.699V174.283Z",
    fill: "#F0F0F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1305 186.952H55.0504V200.233H68.1305V186.952Z",
    fill: "#E6E6E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.12 186.952H56.1992V200.233H68.12V186.952Z",
    fill: "#F5F5F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9354 186.952H74.8552V200.233H87.9354V186.952Z",
    fill: "#E6E6E6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9247 186.952H76.004V200.233H87.9247V186.952Z",
    fill: "#F5F5F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M107.74 186.952H94.66V200.233H107.74V186.952Z",
    fill: "#E6E6E6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M107.729 186.952H95.8087V200.233H107.729V186.952Z",
    fill: "#F5F5F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1305 206.504H55.0504V219.784H68.1305V206.504Z",
    fill: "#E6E6E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M68.12 206.504H56.1992V219.784H68.12V206.504Z",
    fill: "#F5F5F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9354 206.504H74.8552V219.784H87.9354V206.504Z",
    fill: "#E6E6E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9247 206.504H76.004V219.784H87.9247V206.504Z",
    fill: "#F5F5F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M107.74 206.504H94.66V219.784H107.74V206.504Z",
    fill: "#E6E6E6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M107.729 206.504H95.8087V219.784H107.729V206.504Z",
    fill: "#F5F5F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1305 242.308H55.0504V255.588H68.1305V242.308Z",
    fill: "#E6E6E6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M68.12 242.308H56.1992V255.588H68.12V242.308Z",
    fill: "#F5F5F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9354 242.308H74.8552V255.588H87.9354V242.308Z",
    fill: "#E6E6E6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9247 242.308H76.004V255.588H87.9247V242.308Z",
    fill: "#F5F5F5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M107.74 242.308H94.66V255.588H107.74V242.308Z",
    fill: "#E6E6E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M107.729 242.308H95.8087V255.588H107.729V242.308Z",
    fill: "#F5F5F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1305 261.86H55.0504V275.14H68.1305V261.86Z",
    fill: "#E6E6E6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M68.12 261.86H56.1992V275.14H68.12V261.86Z",
    fill: "#F5F5F5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9354 261.86H74.8552V275.14H87.9354V261.86Z",
    fill: "#E6E6E6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9247 261.86H76.004V275.14H87.9247V261.86Z",
    fill: "#F5F5F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M107.74 261.86H94.66V275.14H107.74V261.86Z",
    fill: "#E6E6E6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M107.729 261.86H95.8087V275.14H107.729V261.86Z",
    fill: "#F5F5F5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1305 301.648H55.0504V314.929H68.1305V301.648Z",
    fill: "#E6E6E6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M68.12 301.648H56.1992V314.929H68.12V301.648Z",
    fill: "#F5F5F5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9354 301.648H74.8552V314.929H87.9354V301.648Z",
    fill: "#E6E6E6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9247 301.648H76.004V314.929H87.9247V301.648Z",
    fill: "#F5F5F5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M107.74 301.648H94.66V314.929H107.74V301.648Z",
    fill: "#E6E6E6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M107.729 301.648H95.8087V314.929H107.729V301.648Z",
    fill: "#F5F5F5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1305 321.2H55.0504V334.48H68.1305V321.2Z",
    fill: "#E6E6E6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M68.12 321.2H56.1992V334.48H68.12V321.2Z",
    fill: "#F5F5F5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9354 321.2H74.8552V334.48H87.9354V321.2Z",
    fill: "#E6E6E6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9247 321.2H76.004V334.48H87.9247V321.2Z",
    fill: "#F5F5F5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M107.74 321.2H94.66V334.48H107.74V321.2Z",
    fill: "#E6E6E6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M107.729 321.2H95.8087V334.48H107.729V321.2Z",
    fill: "#F5F5F5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M133.542 229.123H48.4418V230.356H133.542V229.123Z",
    fill: "#E0E0E0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M133.542 290.318H48.4418V291.551H133.542V290.318Z",
    fill: "#E0E0E0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M468.187 142.241H384.109V346.833H468.187V142.241Z",
    fill: "#E0E0E0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M444.24 142.241H384.109V346.833H444.24V142.241Z",
    fill: "#F0F0F0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 159.052H390.307V169.919H412.683V159.052Z",
    fill: "#E6E6E6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 159.052H391.793V169.919H412.683V159.052Z",
    fill: "#F5F5F5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 159.052H416.193V169.919H438.569V159.052Z",
    fill: "#E6E6E6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 159.052H417.679V169.919H438.569V159.052Z",
    fill: "#F5F5F5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 179.5H390.307V190.367H412.683V179.5Z",
    fill: "#E6E6E6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 179.5H391.793V190.367H412.683V179.5Z",
    fill: "#F5F5F5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 179.5H416.193V190.367H438.569V179.5Z",
    fill: "#E6E6E6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 179.5H417.679V190.367H438.569V179.5Z",
    fill: "#F5F5F5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 205.629H390.307V216.496H412.683V205.629Z",
    fill: "#E6E6E6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 205.629H391.793V216.496H412.683V205.629Z",
    fill: "#F5F5F5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 205.629H416.193V216.496H438.569V205.629Z",
    fill: "#E6E6E6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 205.629H417.679V216.496H438.569V205.629Z",
    fill: "#F5F5F5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 220.648H390.307V231.515H412.683V220.648Z",
    fill: "#E6E6E6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 220.648H391.793V231.515H412.683V220.648Z",
    fill: "#F5F5F5"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 220.648H416.193V231.515H438.569V220.648Z",
    fill: "#E6E6E6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 220.648H417.679V231.515H438.569V220.648Z",
    fill: "#F5F5F5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 245.323H390.307V256.189H412.683V245.323Z",
    fill: "#E6E6E6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 245.323H391.793V256.189H412.683V245.323Z",
    fill: "#F5F5F5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 245.323H416.193V256.189H438.569V245.323Z",
    fill: "#E6E6E6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 245.323H417.679V256.189H438.569V245.323Z",
    fill: "#F5F5F5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 260.332H390.307V271.198H412.683V260.332Z",
    fill: "#E6E6E6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 260.332H391.793V271.198H412.683V260.332Z",
    fill: "#F5F5F5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 260.332H416.193V271.198H438.569V260.332Z",
    fill: "#E6E6E6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 260.332H417.679V271.198H438.569V260.332Z",
    fill: "#F5F5F5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 287.187H390.307V298.054H412.683V287.187Z",
    fill: "#E6E6E6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 287.187H391.793V298.054H412.683V287.187Z",
    fill: "#F5F5F5"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 287.187H416.193V298.054H438.569V287.187Z",
    fill: "#E6E6E6"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 287.187H417.679V298.054H438.569V287.187Z",
    fill: "#F5F5F5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 307.013H390.307V317.88H412.683V307.013Z",
    fill: "#E6E6E6"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M412.683 307.013H391.793V317.88H412.683V307.013Z",
    fill: "#F5F5F5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 307.013H416.193V317.88H438.569V307.013Z",
    fill: "#E6E6E6"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M438.569 307.013H417.679V317.88H438.569V307.013Z",
    fill: "#F5F5F5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M468.187 197.06H384.109V198.925H468.187V197.06Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M468.187 237.481H384.109V239.346H468.187V237.481Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M468.187 278.26H384.109V280.126H468.187V278.26Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M468.187 136.191H380.146V142.726H468.187V136.191Z",
    fill: "#E0E0E0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M468.187 136.191H448.066V142.726H468.187V136.191Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M264.364 96.3081H169.315V343.345H264.364V96.3081Z",
    fill: "#E6E6E6"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M229.192 96.3081H134.132V343.345H229.192V96.3081Z",
    fill: "#F0F0F0"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 113.077H142.427V125.662H220.897V113.077Z",
    fill: "#E6E6E6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 113.077H145.473V125.662H220.897V113.077Z",
    fill: "#F5F5F5"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 134.263H142.427V146.847H220.897V134.263Z",
    fill: "#E6E6E6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 134.263H145.473V146.847H220.897V134.263Z",
    fill: "#F5F5F5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 156.27H142.427V168.855H220.897V156.27Z",
    fill: "#E6E6E6"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 156.27H145.473V168.855H220.897V156.27Z",
    fill: "#F5F5F5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 178.288H142.427V190.873H220.897V178.288Z",
    fill: "#E6E6E6"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 178.288H145.473V190.873H220.897V178.288Z",
    fill: "#F5F5F5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 200.296H142.427V212.88H220.897V200.296Z",
    fill: "#E6E6E6"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 200.296H145.473V212.88H220.897V200.296Z",
    fill: "#F5F5F5"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 222.313H142.427V234.898H220.897V222.313Z",
    fill: "#E6E6E6"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 222.313H145.473V234.898H220.897V222.313Z",
    fill: "#F5F5F5"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 246.577H142.427V259.161H220.897V246.577Z",
    fill: "#E6E6E6"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 246.577H145.473V259.161H220.897V246.577Z",
    fill: "#F5F5F5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 270.829H142.427V283.414H220.897V270.829Z",
    fill: "#E6E6E6"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 270.829H145.473V283.414H220.897V270.829Z",
    fill: "#F5F5F5"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 295.092H142.427V307.677H220.897V295.092Z",
    fill: "#E6E6E6"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 295.092H145.473V307.677H220.897V295.092Z",
    fill: "#F5F5F5"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 319.355H142.427V331.94H220.897V319.355Z",
    fill: "#E6E6E6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M220.897 319.355H145.473V331.94H220.897V319.355Z",
    fill: "#F5F5F5"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M266.841 93.8206H131.444V99.8494H266.841V93.8206Z",
    fill: "#F5F5F5"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M266.841 82.9431H131.444V88.972H266.841V82.9431Z",
    fill: "#F5F5F5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M262.341 87.7916H134.132V93.8205H262.341V87.7916Z",
    fill: "#F0F0F0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M264.375 113.077H237.888V125.662H264.375V113.077Z",
    fill: "#E0E0E0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M264.375 133.788H237.888V146.373H264.375V133.788Z",
    fill: "#E0E0E0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M264.375 154.499H237.888V167.084H264.375V154.499Z",
    fill: "#E0E0E0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M264.375 178.278H237.888V190.862H264.375V178.278Z",
    fill: "#E0E0E0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M264.375 200.296H237.888V212.88H264.375V200.296Z",
    fill: "#E0E0E0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M264.375 222.313H237.888V234.898H264.375V222.313Z",
    fill: "#E0E0E0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M264.375 246.566H237.888V259.151H264.375V246.566Z",
    fill: "#E0E0E0"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M264.375 270.829H237.888V283.414H264.375V270.829Z",
    fill: "#E0E0E0"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M264.375 295.092H237.888V307.677H264.375V295.092Z",
    fill: "#E0E0E0"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M264.375 319.355H237.888V331.94H264.375V319.355Z",
    fill: "#E0E0E0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M386.554 182.641H376.099V198.999H386.554V182.641Z",
    fill: "#E0E0E0"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M386.554 209.413H376.099V225.771H386.554V209.413Z",
    fill: "#E0E0E0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M386.554 235.436H376.099V251.794H386.554V235.436Z",
    fill: "#E0E0E0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M386.554 262.945H376.099V279.303H386.554V262.945Z",
    fill: "#E0E0E0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M386.554 289.717H376.099V306.075H386.554V289.717Z",
    fill: "#E0E0E0"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M386.555 166.199H276.527V333.532H386.555V166.199Z",
    fill: "#E6E6E6"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M367.973 166.199H276.538V333.532H367.973V166.199Z",
    fill: "#F0F0F0"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M359.108 182.652H284.759V199.01H359.108V182.652Z",
    fill: "#EBEBEB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M359.108 209.413H284.759V225.771H359.108V209.413Z",
    fill: "#EBEBEB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M359.108 236.184H284.759V252.542H359.108V236.184Z",
    fill: "#EBEBEB"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M359.108 262.945H284.759V279.303H359.108V262.945Z",
    fill: "#EBEBEB"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M359.108 289.717H284.759V306.075H359.108V289.717Z",
    fill: "#EBEBEB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M359.108 182.652H287.5V199.01H359.108V182.652Z",
    fill: "#F5F5F5"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M359.108 209.413H287.5V225.771H359.108V209.413Z",
    fill: "#F5F5F5"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M359.108 236.184H287.5V252.542H359.108V236.184Z",
    fill: "#F5F5F5"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M359.108 262.945H287.5V279.303H359.108V262.945Z",
    fill: "#F5F5F5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M359.108 289.717H287.5V306.075H359.108V289.717Z",
    fill: "#F5F5F5"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M263.5 393.515C376.365 393.515 467.86 388.173 467.86 381.584C467.86 374.994 376.365 369.652 263.5 369.652C150.635 369.652 59.14 374.994 59.14 381.584C59.14 388.173 150.635 393.515 263.5 393.515Z",
    fill: "#F5F5F5"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M147.275 381.583H143.059",
    stroke: "#F3A200",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M135.091 381.583H27.4249",
    stroke: "#F3A200",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.54 1.54"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M23.441 381.583H19.225",
    stroke: "#F3A200",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M398.155 129.289L276.54 131.305L277.996 219.102L399.611 217.085L398.155 129.289Z",
    fill: "#F3A200"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M349.948 130.077L276.42 131.297L277.876 219.093L351.404 217.874L349.948 130.077Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M361.028 135.993L339.853 136.417L339.971 142.319L361.146 141.896L361.028 135.993Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M361.657 204.265L340.485 204.616L340.583 210.518L361.755 210.167L361.657 204.265Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M375.772 185.487C382.635 185.487 388.199 179.192 388.199 171.427C388.199 163.661 382.635 157.366 375.772 157.366C368.909 157.366 363.345 163.661 363.345 171.427C363.345 179.192 368.909 185.487 375.772 185.487Z",
    stroke: "white",
    strokeWidth: 0.203567,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M376.289 159.506V161.867",
    stroke: "white",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M376.826 181.134V183.495",
    stroke: "white",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M365.295 170.963H367.667",
    stroke: "white",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M384.331 170.973H386.702",
    stroke: "white",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M376.278 170.963L376.289 163.69",
    stroke: "white",
    strokeWidth: 0.101783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M376.742 171.437L381.885 176.581",
    stroke: "white",
    strokeWidth: 0.101783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M377.427 170.973C377.427 171.201 377.36 171.423 377.233 171.612C377.107 171.801 376.928 171.948 376.718 172.035C376.508 172.122 376.277 172.144 376.054 172.1C375.831 172.056 375.626 171.946 375.466 171.786C375.305 171.625 375.196 171.42 375.151 171.197C375.107 170.975 375.13 170.744 375.217 170.534C375.304 170.324 375.451 170.144 375.64 170.018C375.829 169.892 376.051 169.825 376.278 169.825C376.429 169.823 376.579 169.852 376.72 169.909C376.86 169.966 376.987 170.051 377.094 170.158C377.201 170.265 377.285 170.392 377.342 170.532C377.4 170.672 377.428 170.822 377.427 170.973V170.973Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M375.772 189.207C384.859 189.207 392.225 181.247 392.225 171.426C392.225 161.606 384.859 153.646 375.772 153.646C366.685 153.646 359.319 161.606 359.319 171.426C359.319 181.247 366.685 189.207 375.772 189.207Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M239.132 325.627C240.966 327.028 277.782 323.065 268.264 257.749C268.264 257.749 285.729 262.186 287.605 261.891C287.605 261.891 313.228 301.174 294.572 320.631C275.916 340.088 248.112 341.279 248.112 341.279L239.132 325.627Z",
    fill: "#F3A200"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M239.132 325.627C240.966 327.028 277.782 323.065 268.264 257.749C268.264 257.749 285.729 262.186 287.605 261.891C287.605 261.891 313.228 301.174 294.572 320.631C275.916 340.088 248.112 341.279 248.112 341.279L239.132 325.627Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M279.932 267.857C280.027 267.857 269.645 268.057 266.167 263.736C262.689 259.414 260.338 251.689 266.662 246.419C272.986 241.149 310.119 218.382 327.604 216.59C345.09 214.799 363.809 226.076 363.809 226.076L340.916 243.004L291.621 254.935L279.932 267.857Z",
    fill: "#263238"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M246.362 315.34L247.321 324.784L258.662 323.825L256.955 314.117L246.362 315.34Z",
    fill: "#FFC3BD"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M244.159 324.099L260.612 323.867L261.782 332.172C261.782 332.172 246.373 332.383 240.038 331.54C233.704 330.697 234.694 327.398 234.694 327.398C234.694 327.398 242.115 327.577 244.159 324.099Z",
    fill: "#263238"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M387.743 348.004C390.2 323.86 375.624 302.602 355.187 300.523C334.75 298.443 316.191 316.33 313.734 340.473C311.278 364.616 325.854 385.874 346.291 387.954C366.728 390.033 385.287 372.147 387.743 348.004Z",
    fill: "#263238"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M324.885 209.834C324.885 209.834 326.592 249.011 303.805 250.129C281.018 251.246 256.533 248.748 256.533 248.748L263.711 319.145L242.346 320.462C242.346 320.462 227.011 260.742 224.597 245.733C222.183 230.725 224.281 220.111 240.122 213.449C255.964 206.788 324.885 209.834 324.885 209.834Z",
    fill: "#F3A200"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M197.362 334.133L225.746 251.689L263.69 209.803C263.69 209.803 230.573 209.929 214.658 219.078C198.742 228.227 198.152 239.22 195.233 252.3C192.313 265.38 180.603 327.292 180.603 327.292L197.362 334.133Z",
    fill: "#F3A200"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M324.885 209.834C324.885 209.834 289.618 208.264 263.753 209.834C263.753 209.834 230.636 209.961 214.721 219.11C198.806 228.258 198.152 239.22 195.233 252.3C192.313 265.38 180.603 327.292 180.603 327.292L197.362 334.133L225.746 251.689C230.52 274.54 242.346 320.42 242.346 320.42L263.711 319.145L256.523 248.79C256.523 248.79 280.997 251.288 303.795 250.171C326.593 249.054 324.885 209.834 324.885 209.834Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M266.662 146.289L253.561 147.88C253.561 147.88 251.284 171.964 249.166 176.644C249.166 176.644 208.871 182.178 192.366 181.703L183.986 187.395L183.691 197.292L191.902 197.534L194.547 191.263C194.547 191.263 200.091 191.021 201.377 187.901C201.377 187.901 244.191 198.24 259.959 186.436C259.98 186.446 269.487 172.481 266.662 146.289Z",
    fill: "#FFC3BD"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M304.205 81.7944C304.205 81.7944 308.306 87.0644 306.746 91.6283C306.315 92.9298 305.557 94.0984 304.543 95.0215C303.529 95.9446 302.295 96.5909 300.959 96.8983C300.959 96.8983 300.19 104.202 295.879 104.413C291.568 104.624 293.012 88.3187 293.012 88.3187L304.205 81.7944Z",
    fill: "#263238"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M271.015 210.013L268.138 162.931L250.283 151.063C250.283 151.063 256.122 130.479 267.294 126.99C278.467 123.501 302.835 115.501 317.612 119.475C332.389 123.448 330.692 140.882 328.152 153.814L325.307 154.489C325.307 154.489 324.864 205.45 324.843 209.834L271.015 210.013Z",
    fill: "#263238"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M303.141 122.384C297.292 128.044 285.36 131.417 282.061 128.602C278.762 125.788 282.925 123.206 286.024 120.023C287.7 118.273 287.647 114.995 287.257 112.381C287.052 111.064 286.749 109.764 286.351 108.492C275.4 107.891 270.857 102.769 270.404 93.7362C269.951 84.7034 274.04 74.2161 274.04 74.2161L281.777 67.618C281.777 67.618 292.317 69.199 300.749 74.996C305.766 78.411 304.28 85.1355 302.203 90.0999C301.323 92.213 300.266 94.2475 299.041 96.1814C297.861 108.545 303.141 122.384 303.141 122.384Z",
    fill: "#FFC3BD"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M276.496 96.2236C276.496 96.2236 280.712 96.4239 282.556 93.8099",
    stroke: "#263238",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M283.21 85.5572C283.21 86.3582 282.725 86.9906 282.156 86.9801C281.587 86.9695 281.176 86.3055 281.197 85.5045C281.218 84.7034 281.682 84.071 282.251 84.0816C282.82 84.0921 283.242 84.7561 283.21 85.5572Z",
    fill: "#263238"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M273.597 85.8101C273.597 86.6111 273.113 87.2435 272.543 87.233C271.974 87.2224 271.563 86.5584 271.584 85.7574C271.605 84.9563 272.069 84.3239 272.638 84.3345C273.207 84.345 273.629 85.0196 273.597 85.8101Z",
    fill: "#263238"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M276.939 92.3554L276.507 85.8944L273.418 92.0287C273.901 92.4384 274.497 92.6895 275.127 92.748C275.757 92.8064 276.39 92.6694 276.939 92.3554Z",
    fill: "#ED847E"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M282.704 80.498C283.513 80.2759 284.374 80.3478 285.134 80.701C285.895 81.0542 286.505 81.6658 286.857 82.4268",
    stroke: "#263238",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M270.625 81.689C270.625 81.689 272.565 79.581 274.841 80.1185",
    stroke: "#263238",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M302.277 90.0999C290.219 90.532 288.722 76.8617 288.722 76.8617C282.757 80.0237 274.082 74.2267 274.082 74.2267L281.819 67.6075C281.819 67.6075 292.359 69.2096 300.791 74.9855C305.839 78.411 304.353 85.1566 302.277 90.0999Z",
    fill: "#263238"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M270.204 78.2319C270.204 78.2319 263.964 74.0792 266.715 71.0858C269.466 68.0924 286.319 73.784 298.915 80.7615C298.915 80.7615 270.067 61.4628 262.225 67.5654C255.743 72.6141 270.119 79.6232 269.687 79.6127L270.204 78.2319Z",
    fill: "#F3A200"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M305.397 76.8195C305.379 79.0051 304.965 81.1692 304.174 83.2068L275.842 69.5048C277.016 68.1494 278.423 67.0144 279.995 66.1531C281.672 65.1939 283.495 64.5174 285.392 64.1505C287.403 63.766 289.461 63.6949 291.494 63.9397C301.855 65.1307 305.449 73.0989 305.397 76.8195Z",
    fill: "#F3A200"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M179.928 216.348C179.928 216.348 147.929 260.616 174.279 328.757",
    stroke: "#263238",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M222.162 239.346C222.162 239.346 222.162 239.43 222.162 239.599C222.162 239.768 222.162 239.863 222.162 240.052V240.158C221.782 244.421 221.077 248.649 220.054 252.806C218.6 258.951 216.671 264.8 215.079 269.501C208.334 289.474 209.114 310.997 209.114 310.997C206.879 308.215 202.79 306.233 197.678 304.842C179.064 299.73 147.465 302.47 147.465 302.47C141.268 280.726 143.481 246.693 149.647 227.636C155.813 208.58 172.909 212.88 172.909 212.88C172.909 212.88 190.953 213.407 193.219 213.165C197.367 212.662 201.565 212.747 205.688 213.418C219.622 215.968 222.974 226.983 222.162 239.346Z",
    fill: "#F3A200"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M361.09 322.307C329.47 350.849 268.433 353.842 223.016 350.68L197.572 304.905L187.264 286.365L220.381 241.728L222.131 239.378C222.131 239.378 222.131 239.462 222.131 239.631C222.131 239.8 222.131 239.894 222.131 240.084V240.189C221.677 248.147 218.747 312.009 242.157 327.671L242.346 327.809C245.514 329.856 249.189 330.98 252.96 331.055C295.911 332.299 294.709 276.247 283.79 264.242L358.318 249.264C358.318 249.264 373.032 286.313 361.09 322.307Z",
    fill: "#F3A200"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M278.193 252.089C278.193 252.089 271.205 257.886 274.81 265.665C278.414 273.443 313.165 258.339 326.846 255.588C340.526 252.837 356.358 250.15 363.166 248.748C369.975 247.346 369.385 227.815 363.82 226.087C358.255 224.358 303.742 233.992 294.699 239.283C288.727 242.909 283.189 247.206 278.193 252.089V252.089Z",
    fill: "#263238"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M295.689 94.9272C295.024 94.2112 294.622 93.2909 294.547 92.3166C294.472 91.3422 294.73 90.3713 295.278 89.5623C296.965 87.0327 300.369 83.017 303.636 86.0209C308.211 90.2369 300.401 97.8995 297.165 96.0445C296.623 95.7433 296.126 95.3672 295.689 94.9272V94.9272Z",
    fill: "#FFC3BD"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M270.204 78.2319C270.204 78.2319 263.964 74.0792 266.715 71.0858C267.937 69.7578 271.595 70.0318 276.538 71.4441C279.717 72.2999 282.831 73.3812 285.855 74.6799C290.198 76.5666 294.814 78.9803 298.915 80.7615C298.915 80.7615 270.067 61.4628 262.225 67.5654C255.743 72.6141 269.223 79.1594 269.698 79.6021L269.93 78.7484L270.204 78.2319Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M273.165 76.4294C273.165 76.4294 266.841 77.4834 271.205 84.2923L273.165 76.4294Z",
    fill: "#263238"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M279.226 72.2767C279.226 72.2767 269.687 68.925 267.031 70.8222C264.375 72.7194 267.158 76.3346 270.193 78.2002L272.628 78.5164L274.061 74.195L277.771 73.7418L279.226 72.2767Z",
    fill: "#263238"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M292.221 67.1227L289.934 70.506L279.995 66.1846C281.672 65.2255 283.495 64.5489 285.392 64.182L292.221 67.1227Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M290.008 107.565C289.351 109.314 288.407 110.942 287.215 112.381C287.01 111.064 286.707 109.764 286.309 108.492C287.587 108.403 288.839 108.089 290.008 107.565Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M195.517 200.253C195.096 207.558 191.934 213.534 188.055 215.01C187.384 215.268 186.665 215.379 185.947 215.336C181.162 215.062 177.684 207.884 178.168 199.315C178.653 190.746 182.932 184.022 187.718 184.296C189.667 184.401 191.386 185.656 192.724 187.669C194.695 190.557 195.802 195.173 195.517 200.253Z",
    fill: "#F5F5F5"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M195.517 200.253C195.096 207.558 191.934 213.534 188.055 215.009C183.628 214.756 180.413 208.127 180.867 200.253C181.32 192.38 185.262 186.13 189.689 186.383C190.829 186.468 191.909 186.932 192.756 187.7V187.7C194.695 190.557 195.802 195.173 195.517 200.253Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M366.339 303.788C358.192 298.065 326.666 292.447 326.666 292.447C307.515 292.447 290.704 309.68 288.385 332.562C286.488 351.176 294.709 368.071 307.958 375.776C307.958 375.776 309.065 376.24 310.92 376.967C317.939 379.739 335.752 386.453 346.281 387.929",
    fill: "#263238"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M387.743 348.004C390.2 323.86 375.624 302.602 355.187 300.523C334.75 298.443 316.191 316.33 313.734 340.473C311.278 364.616 325.854 385.874 346.291 387.954C366.728 390.033 385.287 372.147 387.743 348.004Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M223.889 346.598C226.346 322.455 211.77 301.197 191.333 299.117C170.896 297.038 152.337 314.924 149.88 339.067C147.423 363.211 161.999 384.469 182.436 386.548C202.873 388.628 221.432 370.741 223.889 346.598Z",
    fill: "#263238"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M209.62 307.171L190.774 386.295C188.025 386.74 185.229 386.822 182.458 386.537H182.247C178.632 385.61 180.245 386.611 176.619 385.41C167.396 382.363 154 376.978 154 376.978C139.803 370.074 131.782 353.284 133.732 334.101C136.093 310.86 152.767 293.501 172.392 294.924C172.392 294.924 181.71 296.642 191.301 299.14C195.517 300.194 199.733 301.448 203.201 302.755C205.497 303.986 207.649 305.467 209.62 307.171V307.171Z",
    fill: "#263238"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M223.891 346.549C221.783 367.365 207.691 383.523 190.753 386.253C188.004 386.698 185.208 386.78 182.437 386.495H182.226C178.367 386.079 174.617 384.961 171.159 383.196C156.92 375.976 147.908 358.438 149.879 339.044C152.335 314.918 170.854 297.053 191.28 299.098H191.333C195.48 299.516 199.505 300.745 203.18 302.713V302.713C205.476 303.947 207.629 305.432 209.599 307.14C219.685 315.909 225.556 330.623 223.891 346.549Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M218.758 318.828C218.14 317.843 217.434 316.915 216.65 316.056C211.938 309.627 201.167 307.224 194.115 307.793C188.71 308.321 183.52 310.182 179.011 313.211C173.868 316.541 170.189 321.643 165.088 325.142C155.412 331.824 140.73 331.634 131.012 324.752C130.464 324.362 129.943 323.936 129.452 323.477C128.462 322.446 127.801 321.143 127.555 319.735C127.183 317.977 127.319 316.149 127.945 314.465C130.053 308.541 137.083 303.335 141.521 300.162C150.517 293.815 161.098 290.09 172.087 289.401C203.422 287.24 216.787 314.001 218.758 318.828Z",
    fill: "#F3A200"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M216.587 319.672C209.852 309.954 201.209 307.224 194.158 307.793C188.752 308.321 183.562 310.182 179.054 313.211C173.91 316.541 170.232 321.643 165.13 325.142C155.455 331.824 140.772 331.635 131.055 324.752C130.507 324.362 129.985 323.936 129.495 323.477C128.504 322.446 127.844 321.143 127.597 319.735C127.226 317.977 127.361 316.149 127.987 314.465C131.244 318.228 140.73 327.292 153.579 322.897C169.599 317.363 173.51 300.921 190.637 301.069C204.244 301.227 212.624 311.767 216.587 319.672Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.106 297.263C150.676 294.016 155.818 291.659 161.262 290.318C166.712 288.931 172.355 288.467 177.958 288.947C183.551 289.486 189.029 290.879 194.2 293.079L196.118 293.922L197.994 294.86C199.259 295.451 200.45 296.188 201.673 296.863C202.895 297.537 204.023 298.37 205.193 299.119C206.363 299.867 207.459 300.742 208.576 301.574C203.98 298.495 199.073 295.905 193.936 293.849C188.81 291.792 183.408 290.503 177.905 290.022C172.413 289.497 166.873 289.853 161.494 291.076C158.794 291.675 156.146 292.493 153.579 293.522C150.973 294.525 148.47 295.778 146.106 297.263V297.263Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.234 289.727C178.92 285.332 178.131 280.796 177.884 276.215C177.536 271.651 177.462 267.066 177.557 262.513C177.652 257.96 177.968 253.364 178.39 248.811L179.159 242.002C179.496 239.736 179.791 237.47 180.213 235.215L179.254 248.917L178.874 255.747C178.811 258.023 178.674 260.3 178.664 262.576C178.484 267.13 178.569 271.683 178.737 276.278C178.811 278.555 178.99 280.821 179.222 283.087C179.407 285.321 179.746 287.54 180.234 289.727V289.727Z",
    fill: "black"
  }))), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M242.104 327.577C220.096 313.421 219.222 276.9 219.97 252.806C220.107 248.664 220.276 244.901 220.402 241.665C220.633 238.426 220.633 235.175 220.402 231.937C218.178 215.389 205.53 213.397 205.53 213.397H205.583C219.591 215.968 222.942 226.983 222.131 239.346C222.131 239.346 222.131 239.431 222.131 239.599C222.131 239.768 222.131 239.863 222.131 240.052V240.158C221.656 248.115 218.726 311.977 242.104 327.577Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M240.312 202.846C238.468 204.775 214.616 199.832 210.452 202.045C208.692 202.973 207.923 206.261 206.152 209.866C201.177 217.771 194.178 219.015 193.746 219.078C202.094 212.754 204.423 197.534 200.281 187.911C196.139 178.288 181.309 180.786 180.466 181.071C182.995 179.959 185.715 179.347 188.476 179.268C196.497 178.847 206.278 181.102 209.019 186.182C214.584 196.543 238.446 194.214 240.639 196.933C242.831 199.653 242.157 200.917 240.312 202.846Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M221.635 193.645C220.185 196.321 219.607 199.383 219.981 202.404L240.186 204.68C241.219 203.485 241.982 202.081 242.424 200.564C242.866 199.047 242.976 197.453 242.747 195.89C242.747 195.89 222.731 193.877 221.635 193.645Z",
    fill: "#263238"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M160.282 192.897C160.282 192.897 158.269 188.617 160.682 185.909C155.286 185.424 151.945 184.855 148.467 184.349C147.95 185.919 147.697 187.426 149.521 189.819C151.344 192.211 160.282 192.897 160.282 192.897Z",
    fill: "#263238"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M149.057 219.679C145.557 225.381 142.564 234.508 142.301 249.085",
    stroke: "#F3A200",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M160.577 210.277C158.031 210.867 155.691 212.13 153.8 213.934",
    stroke: "#F3A200",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M317.76 155.332L304.458 156.955C304.458 156.955 302.14 181.397 299.989 186.151C299.989 186.151 259.084 191.779 242.315 191.284L233.809 197.06L233.514 207.115L241.851 207.357L244.539 201.033C244.539 201.033 250.167 200.791 251.463 197.619C251.463 197.619 294.93 208.159 310.941 196.143C310.93 196.101 320.595 181.924 317.76 155.332Z",
    fill: "#FFC3BD"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M209.451 343.387C209.072 356.646 200.387 367.144 190.047 366.849C188.657 366.807 187.28 366.569 185.957 366.143C177.673 363.508 171.707 353.737 172.034 342.301C172.361 331.234 178.463 322.085 186.484 319.545C188.087 319.03 189.766 318.791 191.449 318.839C201.788 319.145 209.841 330.17 209.451 343.387Z",
    fill: "#FAFAFA"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M199.933 343.387C199.607 354.706 193.609 364.013 185.957 366.174C177.673 363.539 171.707 353.768 172.034 342.333C172.361 331.266 178.463 322.117 186.484 319.577C194.453 321.737 200.26 331.666 199.933 343.387Z",
    fill: "#263238"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M371.851 344.441C371.461 357.7 362.776 368.208 352.447 367.903C351.057 367.867 349.679 367.629 348.358 367.197C340.063 364.562 334.097 354.802 334.434 343.355C334.75 332.299 340.853 323.139 348.874 320.599C350.477 320.084 352.156 319.845 353.838 319.893C364.178 320.199 372.231 331.202 371.851 344.441Z",
    fill: "#FAFAFA"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M362.334 344.441C361.996 355.75 356.01 365.057 348.358 367.217C340.063 364.582 334.097 354.822 334.434 343.376C334.75 332.32 340.853 323.16 348.874 320.62C356.853 322.781 362.671 332.71 362.334 344.441Z",
    fill: "#263238"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M388.146 309.511C388.325 322.549 368.479 331.181 335.267 336.62C326.315 338.194 317.166 338.301 308.179 336.936C293.423 334.501 286.214 328.262 286.214 328.262C286.214 328.262 289.966 283.203 327.099 277.491C352.395 273.612 371.43 283.815 381.084 294.808C385.627 299.972 388.094 305.337 388.146 309.511Z",
    fill: "#F3A200"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M388.146 309.511C388.325 322.549 368.479 331.181 335.267 336.62C326.315 338.194 317.166 338.301 308.179 336.936C309.771 324.699 316.917 292.605 347.978 289.274C362.07 287.756 372.947 290.602 381.084 294.808C385.627 299.972 388.093 305.337 388.146 309.511Z",
    fill: "black"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.364 328.462C289.048 322.329 290.51 316.307 292.717 310.544C294.887 304.721 297.883 299.241 301.613 294.27C303.498 291.8 305.615 289.516 307.937 287.451C310.238 285.352 312.773 283.527 315.494 282.012C320.908 278.959 326.907 277.088 333.096 276.521C330.063 277.029 327.08 277.798 324.179 278.819C322.714 279.261 321.333 279.946 319.963 280.526C318.588 281.185 317.248 281.913 315.947 282.708C314.619 283.467 313.397 284.384 312.142 285.238C310.888 286.091 309.729 287.103 308.622 288.168C306.371 290.213 304.321 292.468 302.498 294.903C298.796 299.777 295.778 305.136 293.529 310.829C292.361 313.665 291.355 316.564 290.514 319.514C289.62 322.451 288.902 325.439 288.364 328.462V328.462Z",
    fill: "black"
  }))), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M238.531 313.579L240.723 321.021L263.711 319.102L264.017 308.699L238.531 313.579Z",
    fill: "#F3A200"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M375.393 262.829L425.974 260.774",
    stroke: "#F3A200",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M442.691 251.562L450.206 251.257",
    stroke: "#F3A200",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M399.635 253.312L436.925 251.794",
    stroke: "#F3A200",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M425.732 279.493L456.983 278.229",
    stroke: "#F3A200",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M406.412 280.284L420.03 279.725",
    stroke: "#F3A200",
    strokeWidth: 0.203567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureDelivery);
export default __webpack_public_path__ + "static/media/feature-delivery.6c063c381686c0cd137cf48a626e7a00.svg";
export { ForwardRef as ReactComponent };